import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./newDashboard.css";
import "./newDashboard.overrides.css";
import DashboardHeader from "./DashboardHeader";

// The New Dashboard's header over every other page of the app (App.jsx), in
// place of the old sidebar and header: the same brand, menu, tabs, district
// picker, clock and account controls. A tab opens the dashboard on that tab;
// there are no map controls away from the map.
export default function AppHeader() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Its height, for the page's top padding (App.jsx): it wraps to more rows
  // on narrow screens.
  const rootRef = useRef(null);
  useEffect(() => {
    const node = rootRef.current;
    if (!node || typeof ResizeObserver === "undefined") return undefined;
    const publish = () => document.documentElement.style.setProperty("--mw-header-h", `${Math.ceil(node.getBoundingClientRect().height)}px`);
    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(node);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--mw-header-h");
    };
  }, []);
  return (
    <div className="nd-root nd-page-header" ref={rootRef}>
      <DashboardHeader
        activeTab={null}
        onTab={(tab) => navigate(`/new-dashboard?tab=${tab}`)}
        // The old header hid the district picker on this page too.
        hideDistrict={pathname === "/meter-leak-details"}
      />
    </div>
  );
}
